module.exports = __webpack_public_path__ + "img/select.be2885c0.svg";